import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import axiosInstance from "../api/axios";
import { AuthContext } from "../context/AuthContext";
import styled from "styled-components";

import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  Divider,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";

const Register = () => {
  const [formData, setFormData] = useState({
    email: "",
    phone: "",
    password: "",
    firstName: "",
    lastName: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { fetchUser } = useContext(AuthContext);

  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axiosInstance.post("/users/register", {
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
        first_name: formData.firstName,
        last_name: formData.lastName,
      });
      setSuccess("נרשמת בהצלחה! קוד אימות נשלח לטלפון שלך.");
      setError("");
      navigate("/verify-phone", {
        state: { phone: formData.phone, email: formData.email },
      });
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status === 400 && err.response.data?.detail) {
        setError(`אירעה שגיאה: ${err.response.data.detail}`);
      } else {
        setError("אירעה שגיאה בהרשמה.");
      }
      setSuccess("");
    } finally {
      setLoading(false);
    }
  };

  const onSuccess = async (credentialResponse) => {
    setError("");
    setLoading(true);
    try {
      await axiosInstance.post(
        "/users/google-login",
        { token: credentialResponse.credential },
        { withCredentials: true }
      );
      await fetchUser();
      navigate("/");
    } catch (err) {
      setError("אירעה שגיאה בהתחברות דרך Google.");
    } finally {
      setLoading(false);
    }
  };

  const onError = () => {
    setError("התחברות דרך Google נכשלה.");
  };

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#f4f6f8",
          padding: "20px",
          direction: "rtl", // כיוון מימין לשמאל
        }}
      >
        <Card
          sx={{
            maxWidth: "400px",
            width: "100%",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            borderRadius: "12px",
            position: "relative",
          }}
        >
          {loading && (
            <Overlay>
              <CircularProgress color="primary" />
            </Overlay>
          )}
          <CardContent sx={{ opacity: loading ? 0.5 : 1 }}>
            <Typography variant="h4" textAlign="center" gutterBottom>
              הירשם
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            {success && (
              <Alert severity="success" sx={{ mb: 2 }}>
                {success}
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="אימייל"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                margin="normal"
                inputProps={{ style: { textAlign: "right" } }}
              />
              <TextField
                fullWidth
                label="טלפון"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                margin="normal"
                inputProps={{ style: { textAlign: "right" } }}
              />
              <TextField
                fullWidth
                label="שם פרטי"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                margin="normal"
                inputProps={{ style: { textAlign: "right" } }}
              />
              <TextField
                fullWidth
                label="שם משפחה"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                margin="normal"
                inputProps={{ style: { textAlign: "right" } }}
              />
              <TextField
                fullWidth
                type="password"
                label="סיסמה"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                margin="normal"
                inputProps={{ style: { textAlign: "right" } }}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 2, backgroundColor: "#1976d2" }}
              >
                הירשם
              </Button>
            </form>

            <Divider sx={{ my: 3 }}>או</Divider>

            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <GoogleLogin
                onSuccess={onSuccess}
                onError={onError}
                theme="filled_blue"
                shape="pill"
                text="continue_with"
                style={{
                  marginTop: "20px",
                  width: "400px",
                  textAlign: "center",
                  height: "40px",
                }}
              />
            </Box>

            <Typography variant="body2" sx={{ mt: 3, textAlign: "center" }}>
              כבר יש לך חשבון?{" "}
              <Link
                to="/login"
                style={{ color: "#1976d2", textDecoration: "none" }}
              >
                התחבר כאן
              </Link>
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </GoogleOAuthProvider>
  );
};

export default Register;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;
